import {UseQueryResult, useQuery} from '@tanstack/react-query';

import {DashboardConfig} from 'app/components/Dashboard/types';
import {api} from 'app/modules/Remote';

export function useDashboardConfigs(orgId: string): UseQueryResult<
  {
    [id: string]: {
      widgets: DashboardConfig[];
    };
  },
  Error
> {
  const queryKey = ['dashboard-configs', orgId];
  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await api.dashboardStats(orgId).getDashboardConfigs();
      const json = await response.toJS();
      return json.data;
    },
  });
}
